import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle, ArrowLeft } from 'lucide-react';
import ClienteForm from '../components/ClienteForm';
import { useToast } from '../components/ToastProvider';
import { clientesAPI, describirError } from '../services/api';
import '../styles/Pages.css';

function ClienteNuevo() {
  const navigate = useNavigate();
  const toast = useToast();

  const [enviando, setEnviando] = useState(false);
  const [erroresServidor, setErroresServidor] = useState(null);
  const [duplicados, setDuplicados] = useState(null);
  const [pendiente, setPendiente] = useState(null);

  const enviar = async (datos, { confirmarDuplicado = false } = {}) => {
    setEnviando(true);
    setErroresServidor(null);

    try {
      const { data } = await clientesAPI.crear(datos, { confirmarDuplicado });
      toast.exito('Cliente creado correctamente');
      navigate(`/clientes/${data.id}`, { replace: true });
    } catch (e) {
      const err = describirError(e);

      if (err.possibleDuplicate) {
        // No se crea nada: se muestra la coincidencia y decide la persona.
        setDuplicados(err.coincidencias);
        setPendiente(datos);
      } else if (err.detalles) {
        setErroresServidor(err.detalles);
        toast.error('Revisa los campos marcados.');
      } else {
        toast.error(err.mensaje);
      }
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="page-container">
      <button className="btn btn-ghost volver" onClick={() => navigate('/clientes')}>
        <ArrowLeft size={16} strokeWidth={1.75} />
        Volver a clientes
      </button>

      {duplicados && (
        <div className="aviso-duplicado">
          <AlertTriangle size={17} strokeWidth={1.75} />
          <div className="aviso-duplicado-cuerpo">
            <p className="aviso-duplicado-titulo">Existe un posible cliente duplicado.</p>
            <p className="aviso-duplicado-texto">
              Estos registros coinciden en datos que suelen identificar a la misma persona.
              Revísalos antes de continuar; no se fusiona nada automáticamente.
            </p>

            <ul className="aviso-duplicado-lista">
              {duplicados.map((d) => (
                <li key={d.id}>
                  <button className="enlace-duplicado" onClick={() => navigate(`/clientes/${d.id}`)}>
                    {d.folio} · {d.nombreCompleto}
                  </button>
                  <span className="aviso-duplicado-campos">
                    coincide en {d.coincidePor.join(', ')}
                  </span>
                </li>
              ))}
            </ul>

            <div className="aviso-duplicado-acciones">
              <button className="btn btn-secondary" onClick={() => setDuplicados(null)}>
                Revisar los datos
              </button>
              <button
                className="btn btn-primary"
                disabled={enviando}
                onClick={() => {
                  setDuplicados(null);
                  enviar(pendiente, { confirmarDuplicado: true });
                }}
              >
                Crear de todos modos
              </button>
            </div>
          </div>
        </div>
      )}

      <ClienteForm
        modo="crear"
        valorInicial={null}
        enviando={enviando}
        erroresServidor={erroresServidor}
        onSubmit={(datos) => enviar(datos)}
        onCancelar={() => navigate('/clientes')}
      />
    </div>
  );
}

export default ClienteNuevo;
